var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiSkeletonSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 238,
    viewBox: "0 0 366 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M336.5 10H15.5218C13.0245 10 11.0001 12.0093 11.0001 14.4878L11 196.012C11 198.491 13.0245 200.5 15.5217 200.5H336.5C338.997 200.5 341.022 198.491 341.022 196.012L341.022 14.4878C341.022 12.0093 338.997 10 336.5 10Z",
    fill: "#0973BA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 43,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 283,
    y: 53,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 53,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 93,
    width: 23,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 93,
    width: 23,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 93,
    width: 23,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 93,
    width: 14,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 63,
    width: 14,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 103,
    width: 14,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 125,
    width: 14,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 103,
    width: 53,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 125,
    width: 29,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 135,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 145,
    width: 33,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 135,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 135,
    width: 36,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 145,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 125,
    width: 52,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 63,
    width: 39,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 73,
    width: 54,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 63,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 33,
    width: 51,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 43,
    width: 51,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 33,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 43,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 33,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 53,
    width: 42,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 53,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#0973BA"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 33,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 63,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 157,
    width: 24,
    height: 4,
    rx: 2,
    transform: "rotate(-180 195 157)",
    fill: "#3A8FC8"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 93,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 127,
    width: 24,
    height: 4,
    rx: 2,
    transform: "rotate(-180 195 127)",
    fill: "#3A8FC8"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 43,
    width: 51,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 73,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 147,
    width: 9,
    height: 4,
    rx: 2,
    transform: "rotate(-180 128 147)",
    fill: "#3A8FC8"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 73,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 147,
    width: 9,
    height: 4,
    rx: 2,
    transform: "rotate(-180 142 147)",
    fill: "#3A8FC8"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 103,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 117,
    width: 9,
    height: 4,
    rx: 2,
    transform: "rotate(-180 136 117)",
    fill: "#3A8FC8"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 103,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 117,
    width: 9,
    height: 4,
    rx: 2,
    transform: "rotate(-180 150 117)",
    fill: "#3A8FC8"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 53,
    width: 51,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 167,
    width: 51,
    height: 4,
    rx: 2,
    transform: "rotate(-180 192 167)",
    fill: "#3A8FC8"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 83,
    width: 51,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 137,
    width: 51,
    height: 4,
    rx: 2,
    transform: "rotate(-180 192 137)",
    fill: "#3A8FC8"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 33,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 63,
    width: 51,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 157,
    width: 51,
    height: 4,
    rx: 2,
    transform: "rotate(-180 167 157)",
    fill: "#3A8FC8"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 93,
    width: 51,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 127,
    width: 51,
    height: 4,
    rx: 2,
    transform: "rotate(-180 167 127)",
    fill: "#3A8FC8"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 53,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 167,
    width: 32,
    height: 4,
    rx: 2,
    transform: "rotate(-180 139 167)",
    fill: "#3A8FC8"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 83,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 137,
    width: 32,
    height: 4,
    rx: 2,
    transform: "rotate(-180 139 137)",
    fill: "#3A8FC8"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 33,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 63,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 157,
    width: 15,
    height: 4,
    rx: 2,
    transform: "rotate(-180 112 157)",
    fill: "#3A8FC8"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 93,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 127,
    width: 15,
    height: 4,
    rx: 2,
    transform: "rotate(-180 112 127)",
    fill: "#3A8FC8"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 63,
    width: 21,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 157,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-180 93 157)",
    fill: "#3A8FC8"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 93,
    width: 21,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 127,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-180 93 127)",
    fill: "#3A8FC8"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 53,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 167,
    width: 15,
    height: 4,
    rx: 2,
    transform: "rotate(-180 105 167)",
    fill: "#3A8FC8"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 73,
    width: 42,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 147,
    width: 42,
    height: 4,
    rx: 2,
    transform: "rotate(-180 188 147)",
    fill: "#3A8FC8"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 83,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 137,
    width: 15,
    height: 4,
    rx: 2,
    transform: "rotate(-180 105 137)",
    fill: "#3A8FC8"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 73,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 147,
    width: 32,
    height: 4,
    rx: 2,
    transform: "rotate(-180 114 147)",
    fill: "#3A8FC8"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 43,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 103,
    width: 42,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 117,
    width: 42,
    height: 4,
    rx: 2,
    transform: "rotate(-180 196 117)",
    fill: "#3A8FC8"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 43,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 103,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#3A8FC8"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 117,
    width: 32,
    height: 4,
    rx: 2,
    transform: "rotate(-180 122 117)",
    fill: "#3A8FC8"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 33,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#054570"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 63,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#054570"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 43,
    width: 17,
    height: 4,
    rx: 2,
    fill: "#054570"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 53,
    width: 33,
    height: 4,
    rx: 2,
    fill: "#054570"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 73,
    width: 33,
    height: 4,
    rx: 2,
    fill: "#054570"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 3L64 193.5",
    stroke: "#05386B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203 3L203 192",
    stroke: "#05386B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 16.5,
    r: 2.5,
    fill: "#042E4A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 16.5,
    r: 2.5,
    fill: "#042E4A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 16.5,
    r: 2.5,
    fill: "#042E4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M332.022 108.5V6.4878C332.022 4.00926 329.997 2 327.5 2H6.52181C4.02452 2 2.00007 4.00926 2.00007 6.4878L2 188.012C2 190.491 4.02445 192.5 6.52174 192.5H281",
    stroke: "#0973BA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357 228.424L357 116.576C357 115.705 356.272 115 355.374 115L289.626 115C288.728 115 288 115.705 288 116.576L288 228.424C288 229.295 288.728 230 289.625 230L355.374 230C356.272 230 357 229.295 357 228.424Z",
    stroke: "#5C853A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M366 236.424L366 124.576C366 123.705 365.272 123 364.374 123L298.626 123C297.728 123 297 123.705 297 124.576L297 236.424C297 237.295 297.728 238 298.625 238L364.374 238C365.272 238 366 237.295 366 236.424Z",
    fill: "#88C656"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329.708 152.456C329.772 152.248 329.795 152.029 329.774 151.813C329.754 151.596 329.691 151.386 329.589 151.193C329.487 151.001 329.348 150.831 329.181 150.692C329.013 150.553 328.82 150.449 328.612 150.385C328.404 150.321 328.186 150.299 327.969 150.319C327.752 150.34 327.542 150.403 327.35 150.505C327.157 150.606 326.987 150.745 326.849 150.913C326.71 151.08 326.606 151.274 326.542 151.482L313.292 194.544C313.163 194.964 313.205 195.418 313.411 195.806C313.617 196.195 313.968 196.485 314.388 196.614C314.808 196.744 315.262 196.701 315.65 196.495C316.039 196.289 316.329 195.938 316.458 195.518L329.708 152.456ZM311.079 160.733C311.233 160.887 311.356 161.07 311.439 161.271C311.523 161.473 311.565 161.688 311.565 161.906C311.565 162.124 311.523 162.34 311.439 162.541C311.356 162.742 311.233 162.925 311.079 163.079L300.654 173.5L311.079 183.921C311.39 184.232 311.565 184.654 311.565 185.094C311.565 185.533 311.39 185.955 311.079 186.266C310.768 186.577 310.346 186.752 309.906 186.752C309.466 186.752 309.045 186.577 308.734 186.266L297.14 174.672C296.986 174.519 296.863 174.336 296.78 174.135C296.696 173.933 296.653 173.718 296.653 173.5C296.653 173.282 296.696 173.066 296.78 172.865C296.863 172.664 296.986 172.481 297.14 172.327L308.734 160.733C308.888 160.579 309.07 160.457 309.271 160.373C309.473 160.29 309.688 160.247 309.906 160.247C310.124 160.247 310.34 160.29 310.541 160.373C310.742 160.457 310.925 160.579 311.079 160.733ZM331.921 160.733C331.767 160.887 331.645 161.07 331.561 161.271C331.478 161.473 331.435 161.688 331.435 161.906C331.435 162.124 331.478 162.34 331.561 162.541C331.645 162.742 331.767 162.925 331.921 163.079L342.346 173.5L331.921 183.921C331.767 184.075 331.645 184.258 331.562 184.459C331.478 184.66 331.435 184.876 331.435 185.094C331.435 185.311 331.478 185.527 331.562 185.728C331.645 185.929 331.767 186.112 331.921 186.266C332.075 186.42 332.258 186.542 332.459 186.626C332.66 186.709 332.876 186.752 333.094 186.752C333.312 186.752 333.527 186.709 333.728 186.626C333.93 186.542 334.112 186.42 334.266 186.266L345.86 174.672C346.014 174.519 346.137 174.336 346.22 174.135C346.304 173.933 346.347 173.718 346.347 173.5C346.347 173.282 346.304 173.066 346.22 172.865C346.137 172.664 346.014 172.481 345.86 172.327L334.266 160.733C334.113 160.579 333.93 160.457 333.729 160.373C333.527 160.29 333.312 160.247 333.094 160.247C332.876 160.247 332.66 160.29 332.459 160.373C332.258 160.457 332.075 160.579 331.921 160.733Z",
    fill: "#47682D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiSkeletonSvg);
export default __webpack_public_path__ + "static/media/APISkeletonSVG.b7a07f6d7993dd5986fbc5c2893b9eb6.svg";
export { ForwardRef as ReactComponent };